import { createFormInteractionEventFromField } from '../event-factories';
import {
  FormAttributionAttributes
} from '../types';
import { getFormName, getIsFieldEnabled, logger } from '../utils';

import { trackEvent } from './event-tracker';

import type {
  FormAttributionInteraction} from '../types';

export const createFormAttributionHandler = (
  interaction: FormAttributionInteraction,
) => {
  return (event: Event) => {
    const target = event.target;

    if (
      !(target instanceof HTMLInputElement) &&
      !(target instanceof HTMLSelectElement)
    ) {
      return;
    }

    const enabled = getIsFieldEnabled(target);

    if (!enabled) {
      logger.warn(
        `Dropping form attribution event due to disabled field. The dropped field contains the attribute \`${FormAttributionAttributes.FormEnabled}\` with a value which evaluates to false.`,
        target,
      );

      return;
    }

    const formName = getFormName(target);

    if (typeof formName === 'undefined') {
      logger.warn(
        `Dropping form attribution event due to missing form name. Either add a parent form with a name or add the attribute \`${FormAttributionAttributes.FormName}\` to the following field:`,
        target,
      );

      return;
    }

    const interactionEvent = createFormInteractionEventFromField({
      interaction,
      formName,
      field: target,
    });

    trackEvent(interactionEvent);
  };
};
